var getDisputeReason = function (userAnswers) {
    var answer = userAnswers === null || userAnswers === void 0 ? void 0 : userAnswers.find(function (userAnswer) { return userAnswer.disputeReason.length > 0; });
    return (answer === null || answer === void 0 ? void 0 : answer.disputeReason) || '';
};
export var getOriginalDisputeReason = function (transactions, transactionId) {
    var _a;
    var originalDisputeReason = (_a = transactions.find(function (transaction) { return transaction.transactionId === transactionId; })) === null || _a === void 0 ? void 0 : _a.disputeReason;
    return originalDisputeReason !== null && originalDisputeReason !== void 0 ? originalDisputeReason : '';
};
export default getDisputeReason;
//# sourceMappingURL=getDisputeReason.js.map